<template>
	<div class="keys-detail">
		<div class="effect-steps">
			<div class="keys-con">
				<div class="keys-title">Custom key measurement adding tutorial</div>
				<div class="keys-time">2019-07-30 20:56:35</div>
			</div>

			<div class="keys-step">
				<div class="step-item first-item">
					<div class="step-title">
						<p style="margin-bottom: 22px;">
							M2 fixture (tool change height leveling and cutting calibration have been
							done)
						</p>
						<div class="step-no"><h3 class="x-inline">Step 1</h3><span
						class="">: Push the M2 fixture to the left limit of the
							platform.</span></div>
						<ul class="detail-con">
							<li><p>①</p></li>
							<li><p>②</p></li>
							<li><img :src="keyImage_01" alt="keyImage_01"/></li>
							<li><img :src="keyImage_02" alt="keyImage_02"/></li>
							<li>
								<div>(P1)</div>
							</li>
							<li>
								<div>(P2)</div>
							</li>
						</ul>
					</div>
				</div>

				<div class="step-item second-item">
					<div class="step-title">
						<div class="step-no"><h3 class="x-inline">Step 2</h3><span
						class="">: Tighten the screws that fix the fixture (do not replace the screws) and
							pull the fixture to the right to ensure	that the fixture will not move.</span></div>
						<ul class="detail-con">
							<li><p>①</p></li>
							<li><p>②</p></li>
							<li><img :src="keyImage_03" alt="keyImage_03"/></li>
							<li><img :src="keyImage_04" alt="keyImage_04"/></li>
							<li>
								<div>(P3)</div>
							</li>
							<li>
								<div>(P4)</div>
							</li>
						</ul>
					</div>
				</div>

				<div class="step-item third-item">
					<div class="step-title">
						<div class="step-no"><h3 class="x-inline">Step 3</h3><span
						class="">: Then do the M2 fixture calibration again (as long as the fixture is disassembled, you need to re-calibrate the.</span>
						</div>
						<ul class="detail-con">
							<li><p>①</p></li>
							<li><p>②</p></li>
							<li><img :src="keyImage_05" alt="keyImage_05"/></li>
							<li><img :src="keyImage_06" alt="keyImage_06"/></li>
							<li>
								<div>(P5)</div>
							</li>
							<li>
								<div>(P6)</div>
							</li>
						</ul>
					</div>
				</div>

				<div class="step-item fourth-item">
					<div class="step-title">
						<div class="step-no"><h3 class="x-inline">Step 4</h3><span
						class="">: Select the correct fixture surface, place the key in the slot in the
							middle of the fixture, press the key with two fingers, and press the key against the surface of the middle slot of the M2 fixture (the shoulder is aligned with the back of the fixture).</span>
						</div>
						<ul class="detail-con">
							<li><p>Head aligned</p></li>
							<li><p>Shoulder alignment</p></li>
							<li><img :src="keyImage_07" alt="keyImage_07"/></li>
							<li><img :src="keyImage_08" alt="keyImage_08"/></li>
							<li>
								<div>(P7)</div>
							</li>
							<li>
								<div>(P8)</div>
							</li>
						</ul>
					</div>
				</div>

				<div class="step-item fifth-item" style="height: 50px;">
					<div class="step-title">
						<div class="step-no"><h3 class="x-inline">Step 5</h3><span
						class="">: Slowly rotate the red knob on the right side of the fixture to fix the side of the key (do not loosen your fingers, and you don't need to screw it too hard to prevent the key from deforming).</span>
						</div>
					</div>
				</div>

				<div class="step-item sixth-item">
					<div class="step-title">
						<div class="step-no"><h3 class="x-inline">Step 6</h3><span
						class="">: Start learning or start cutting.</span></div>
						<ul class="detail-con">
							<li><img :src="keyImage_09" alt="keyImage_09"/></li>
							<li class="x-clear">
								<div>(P9)</div>
							</li>
						</ul>
					</div>
				</div>

				<div class="steps-remark x-clear">
					<div class="sss">
						<ul>
							<li>1. Steps that must be redone after replacing the milling cutter or probe:</li>
							<li>①The tool change height is leveled;</li>
							<li>②M1 fixture calibration;</li>
							<li>③Cutting calibration;</li>
							<li>
								Without changing the milling cutter or probe, as long as the fixture has been disassembled, it must be re-calibrated (regardless of M1 or M2);
							</li>
						</ul>

						<p>
							2.There will be errors in the M2 fixture due to excessive iron filings, so it is necessary to clean the iron filings inside	the fixture regularly. When disassembling-hold the right side of the clamp with only one hand to prevent the clamp from flying when all loosened, turn the right knob with one hand to disassemble the clamp.</p>


						<ul class="detail-con">
							<li><p>①</p></li>
							<li><p>②</p></li>
							<li><img :src="keyImage_10" alt="keyImage_10"/></li>
							<li><img :src="keyImage_11" alt="keyImage_11"/></li>
							<li>
								<div>(P10)</div>
							</li>
							<li>
								<div>(P11)</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import keyImage_01 from '@/assets/resource/images/support/image_support_article_details_p1.png'
    import keyImage_02 from '@/assets/resource/images/support/image_support_article_details_p2.png'
    import keyImage_03 from '@/assets/resource/images/support/image_support_article_details_p3.png'
    import keyImage_04 from '@/assets/resource/images/support/image_support_article_details_p4.png'
    import keyImage_05 from '@/assets/resource/images/support/image_support_article_details_p5.png'
    import keyImage_06 from '@/assets/resource/images/support/image_support_article_details_p6.png'
    import keyImage_07 from '@/assets/resource/images/support/image_support_article_details_p7.png'
    import keyImage_08 from '@/assets/resource/images/support/image_support_article_details_p8.png'
    import keyImage_09 from '@/assets/resource/images/support/image_support_article_details_p9.png'
    import keyImage_10 from '@/assets/resource/images/support/image_support_article_details_p10.png'
    import keyImage_11 from '@/assets/resource/images/support/image_support_article_details_11.png'
    export default {

        data(){
            return {
                keyImage_01: keyImage_01,
                keyImage_02: keyImage_02,
                keyImage_03: keyImage_03,
                keyImage_04: keyImage_04,
                keyImage_05: keyImage_05,
                keyImage_06: keyImage_06,
                keyImage_07: keyImage_07,
                keyImage_08: keyImage_08,
                keyImage_09: keyImage_09,
                keyImage_10: keyImage_10,
                keyImage_11: keyImage_11
            };
        }

    }

</script>


<style scoped="">
	div.sss > ul:first-child {
		margin-bottom: 28px;
	}

	.steps-remark > div.sss {
		text-align: left;
	}

	.step-no {
		width: 100%;
		text-align: left;
	}

	.detail-con > li:nth-last-child(1), .detail-con > li:nth-last-child(2) {
		margin-top: 28px;
	}

	.step-title p {
		font-family: Open Sans;
		font-size: 16px;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 28px;
	}

	.step-item {
		height: 451px;
	}

	.detail-con {
		margin-top: 44px;
		margin-bottom: 64px;
	}

	.detail-con > li {
		width: calc((100% - 24px) / 2);
		height: 28px;
		float: left;
	}

	.detail-con > li:nth-child(even) {
		margin-left: 24px;
	}

	.detail-con > li:nth-child(1), .detail-con > li:nth-child(2) {
		text-align: left;
	}

	.detail-con > li:nth-child(3), .detail-con > li:nth-child(4) {
		height: 237px;
	}

	.keys-con {
		margin-top: 44px;
		margin-bottom: 44px;
		padding-bottom: 44px;
		width: 90%;
		text-align: left;
		border-bottom: 1px solid #D7D7D7;
	}

	.keys-step {
		width: 90%;
		margin-top: 44px;
		margin-bottom: 44px;
	}

	.effect-steps {
		width: 70%;
		height: 100%;
		margin-left: calc(5% + 54px);
	}

	.keys-time {
		font-family: Open SB;
		font-size: 16px;
		color: #515555;
		letter-spacing: 0;
	}

	.keys-title {
		font-family: "Open SB";
		font-size: 32px;
		color: #3B3A38;
		letter-spacing: 0;
	}

	.keys-detail {
		width: 100%;
		height: 3437px;
		overflow: hidden;
	}

</style>


// WEBPACK FOOTER //
// src/components/zh-cn/support/support-detail.vue